import React, { FunctionComponent } from 'react';
import styles from '../../../../styles/ArticleContent.module.scss';

type Props = {
    content: string;
};

const removeWrapper = (content: string) => {
    return content.replace(/(<\/?p>)/g, '');
};

export const Paragraph: FunctionComponent<Props> = ({ content }) => {
    content = removeWrapper(content);

    return <p className={styles.paragraphBlock} dangerouslySetInnerHTML={{ __html: content }}></p>;
};
